module.exports = __webpack_public_path__ + "static/media/miniqr.45525b6e.png";